import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoOperStatusTerminais({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operstatusterminais', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoOperStatusTerminais({ payload }) {
  try {
    const { term_identificacao, params } = payload;

    yield call(api.delete, `operstatusterminais/${term_identificacao}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaooperstatusterminais, params } = payload;

    yield call(api.post, 'operstatusterminais', operacaooperstatusterminais);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operstatusterminais');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { term_identificacao } = payload;

    const { data } = yield call(
      api.get,
      `operstatusterminais/${term_identificacao}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaooperstatusterminais, params } = payload;

    yield call(api.put, 'operstatusterminais', operacaooperstatusterminais);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operstatusterminais');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {

    const { params } = payload;

    const response = yield call(api.get, 'operstatusterminais', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* refresh() {
  try {

    const { params } = yield select((state) => state.operacaooperstatusterminais)

    const response = yield call(api.get, 'operstatusterminais', {
      params: { ...params, pesquisalista: true },
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaooperstatusterminais/OPERSTATUSTERMINAIS_IN_REQUEST',
    requestOperacaoOperStatusTerminais
  ),
  takeLatest(
    '@operacaooperstatusterminais/DELETE_OPERSTATUSTERMINAIS',
    deleteOperacaoOperStatusTerminais
  ),
  takeLatest(
    '@operacaooperstatusterminais/SUCCESS_REMOVE',
    requestOperacaoOperStatusTerminais
  ),
  takeLatest('@operacaooperstatusterminais/STORE_OPERSTATUSTERMINAIS', store),
  takeLatest('@operacaooperstatusterminais/FIND_OPERSTATUSTERMINAIS', find),
  takeLatest('@operacaooperstatusterminais/UPDATE_OPERSTATUSTERMINAIS', update),
  takeLatest('@operacaooperstatusterminais/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaooperstatusterminais/REFRESH', refresh)
]);
